// extracted by mini-css-extract-plugin
export default {"searchInput":"Treatments_searchInput__ODyaR","cardContainer":"Treatments_cardContainer__FNULF","card":"Treatments_card__RsG2w","cardTitle":"Treatments_cardTitle__oH9jw"};